import { DOMESTIC, EXPORT, IMPORT, REPOSITION } from 'config/order-types';

/* REMOVE ONCE ORDER TYPES ARE INTRO'D TO MASTER REFERENCE NUMBERS */
export const BOOKING_NUMBER = 'booking_number';
export const MASTER_BOL = 'master_bol';
export const MASTER_REFERENCE_TYPES = [BOOKING_NUMBER, MASTER_BOL];
/* END */

export function getOrderMasterReferenceType(order_type) {
  switch (order_type) {
    case EXPORT:
      return BOOKING_NUMBER;
    case IMPORT:
      return MASTER_BOL;
    case REPOSITION:
      return MASTER_BOL;
    case DOMESTIC:
      return null;
    default:
      return null;
  }
}

export function getOrderMasterReferenceBookingTimeRequirement(
  bookingTimeRequirements,
  orderType,
) {
  let mappedBookingTimeRequirements = [];
  const masterReferenceType = getOrderMasterReferenceType(orderType);
  const masterReferenceRequirement = bookingTimeRequirements.find(
    ({ reference_number }) => reference_number === masterReferenceType,
  );
  if (masterReferenceRequirement) {
    mappedBookingTimeRequirements.unshift(masterReferenceRequirement);
  }
  return mappedBookingTimeRequirements;
}

export function mapOrderMasterReferenceBookingTimeRequirement(
  bookingTimeRequirements,
  orderType,
) {
  try {
    const mappedBookingTimeRequirements =
      getOrderMasterReferenceBookingTimeRequirement(
        bookingTimeRequirements,
        orderType,
      );
    const nonMasterReferenceBookingRequirements =
      bookingTimeRequirements.filter(
        ({ reference_number }) =>
          !MASTER_REFERENCE_TYPES.includes(reference_number),
      );

    return mappedBookingTimeRequirements.concat(
      nonMasterReferenceBookingRequirements,
    );
  } catch (e) {
    console.error('Unable to map booking time reference numbers: ', e.message);
  }
}
